import type { UserFileRead } from '@/uppy-file-upload/schemas'
import type { FolderResponse } from '@/user_files/folders/schemas'
import type {
  FileRenamePrecondition,
  FileSelectionPrecondition,
  FolderPathPrecondition,
  FolderRenamePrecondition,
  FolderSelectionPrecondition,
} from '@/user_files/schemas/preconditions'

export function buildFileRenamePrecondition(file: Pick<UserFileRead, 'id' | 'folder_id' | 'original_filename'>): FileRenamePrecondition {
  return {
    id: file.id,
    folder_id: file.folder_id,
    original_filename: file.original_filename,
  }
}

export function buildFolderRenamePrecondition(folder: Pick<FolderResponse, 'id' | 'parent_id' | 'path' | 'name'>): FolderRenamePrecondition {
  return {
    id: folder.id,
    parent_id: folder.parent_id,
    path: folder.path,
    name: folder.name,
  }
}

export function buildFileSelectionPrecondition(file: Pick<UserFileRead, 'id' | 'folder_id'>): FileSelectionPrecondition {
  return {
    id: file.id,
    folder_id: file.folder_id,
  }
}

export function buildFolderSelectionPrecondition(folder: Pick<FolderResponse, 'id' | 'parent_id' | 'path'>): FolderSelectionPrecondition {
  return {
    id: folder.id,
    parent_id: folder.parent_id,
    path: folder.path,
  }
}

export function buildFolderPathPrecondition(folder: Pick<FolderResponse, 'id' | 'path'>): FolderPathPrecondition {
  return {
    id: folder.id,
    path: folder.path,
  }
}

export function selectPreconditionsById<T extends { id: string }>(preconditions: readonly T[] | undefined, ids: readonly string[]): T[] | undefined {
  if (!preconditions || preconditions.length === 0) return undefined

  const byId = new Map(preconditions.map((precondition) => [precondition.id, precondition]))
  const selected = ids.map((id) => byId.get(id)).filter((precondition): precondition is T => Boolean(precondition))

  return selected.length > 0 ? selected : undefined
}
